import {valueSchema, validationSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'number_of_male_temporary_workers'

export const dataPointDefinition = {
  retracedId: 'number_of_male_temporary_workers',
  name: 'Number of male temporary workers:',
  description:
    'Temporary workers are those hired by the facility for a specific period of time, or to complete a specific task or project that is limited in duration. Do not include casual workers (who work occasionally and intermittently, and are employed for a specific number of hours, days or weeks).',
  meta: {
    rangeValidation: true,
    optionalRange: true,
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-wor-8',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1220,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = async (data, {validatorFn}) => {
  try {
    validate({value: data, schema: valueSchema})

    if (!validatorFn) {
      return data
    }

    if (validatorFn && typeof validatorFn !== 'function') {
      throw new Error(`expect range limits function to be a function, got ${typeof validatorFn}`)
    }

    const {value} = data

    const rangeValues = await validatorFn()
    validate({value: rangeValues, schema: validationSchema})

    const {min, max} = rangeValues
    if (min && value < min) {
      throw new Error('data mismatch, value is less than minimum allowed value')
    }

    if (max && value > max) {
      throw new Error('data mismatch, value is greater than maximum allowed value')
    }

    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
